<template>
  <section class="contact" id="contact">
    <div class="container">
      <h2>{{ $t('contact.title') }}</h2>
      <p class="subtitle">{{ $t('contact.subtitle') }}</p>
      
      <div class="contact-actions">
        <a href="https://calendar.app.google/FdXEfiQegAh6MCtz8" target="_blank" rel="noopener noreferrer" class="cta-button">
          {{ $t('contact.bookCall') }}
        </a>
        
        <div class="email-info">
          <p>{{ $t('contact.emailUs') }}</p>
          <a :href="'mailto:' + $t('contact.email')" class="email-link">{{ $t('contact.email') }}</a>
        </div>

        <div class="secret-share-callout">
          <div class="callout-header">
            <span class="callout-badge">🔒 {{ $t('contact.secretShare.badge') }}</span>
            <h3>{{ $t('contact.secretShare.title') }}</h3>
          </div>
          <p class="callout-text">{{ $t('contact.secretShare.description') }}</p>
          <router-link to="/share" class="secret-share-btn">
            {{ $t('contact.secretShare.cta') }} →
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.contact {
  padding: 80px 20px;
  background-color: var(--gray-light);
  text-align: center;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: var(--text-color);
}

.subtitle {
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto 40px;
  opacity: 0.8;
}

.contact-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.cta-button {
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  padding: 16px 32px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 15px rgba(21, 91, 213, 0.3);
}

.cta-button:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
}

.email-info p {
  margin-bottom: 5px;
  opacity: 0.7;
}

.email-link {
  color: var(--primary-color);
  font-weight: 600;
  text-decoration: none;
  font-size: 1.1rem;
}

.email-link:hover {
  text-decoration: underline;
}

.secret-share-callout {
  margin-top: 15px;
  background-color: var(--white);
  border: 1px solid rgba(0, 85, 255, 0.18);
  border-radius: 12px;
  padding: 24px 28px;
  max-width: 600px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.04);
}

.callout-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.callout-badge {
  display: inline-block;
  background-color: var(--primary-light);
  color: var(--primary-dark);
  font-size: 0.8rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
}

.secret-share-callout h3 {
  font-size: 1.2rem;
  color: var(--text-color);
  margin: 0;
}

.callout-text {
  font-size: 0.95rem;
  color: var(--text-color);
  opacity: 0.85;
  line-height: 1.5;
  margin: 0 0 16px;
}

.secret-share-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--primary-color);
  font-weight: 700;
  text-decoration: none;
  font-size: 0.95rem;
  border: 1px solid var(--primary-color);
  padding: 8px 18px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.secret-share-btn:hover {
  background-color: var(--primary-color);
  color: white;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .contact {
    padding: 40px 15px;
  }
  h2 {
    font-size: 1.8rem;
  }
  .subtitle {
    font-size: 1rem;
  }
  .cta-button {
    padding: 14px 24px;
    font-size: 1rem;
    width: 100%;
    text-align: center;
  }
}
</style>
